// Aktif ekran turunu süren bileşen.
//
// Adım listesi manifest'ten gelir, ama GÖSTERİLEN adımlar DOM'da gerçekten
// çözülenlerdir. Bir ekranın filtre çubuğu yetkiye göre çizilmiyorsa o adım hiç
// var olmaz: sayaç "4 adımdan 3." deyip boş çıkmak yerine "3 adımdan 3." der.

import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { screenTourFor } from "./screen-tours";
import { Spotlight } from "./spotlight";
import { useTour } from "./tour-provider";
import { useResolvableAnchors } from "./use-resolvable-anchors";

/**
 * Bu ekranda GERÇEKTEN çerçevelenebilecek çapalar, manifest sırasında.
 *
 * Tetikleyici de bunu okur: boş dönerse düğme hiç çizilmez. Her zaman boş açılan
 * bir düğme, kullanıcıya ürünün bozuk olduğunu öğretir.
 */
export function useResolvableScreenAnchors(menuKey: string | null): readonly string[] {
  return useResolvableAnchors(menuKey === null ? null : screenTourFor(menuKey), "main");
}

export function ScreenTour(): React.ReactElement | null {
  const { t } = useTranslation();
  const tour = useTour();
  const active = tour?.activeScreenTour ?? null;
  const menuKey = active?.menuKey ?? null;
  const anchors = useResolvableScreenAnchors(menuKey);

  const stepIndex = Math.min(active?.stepIndex ?? 0, Math.max(0, anchors.length - 1));

  const advance = useCallback(() => {
    if (tour === null) return;
    if (stepIndex >= anchors.length - 1) tour.endScreenTour();
    else tour.setScreenTourStep(stepIndex + 1);
  }, [tour, stepIndex, anchors.length]);

  const back = useCallback(() => {
    tour?.setScreenTourStep(stepIndex - 1);
  }, [tour, stepIndex]);

  if (tour === null || active === null || anchors.length === 0) return null;
  const anchorId = anchors[stepIndex];
  if (anchorId === undefined) return null;

  return (
    <Spotlight
      anchorId={anchorId}
      scope="main"
      stepIndex={stepIndex}
      stepCount={anchors.length}
      title={t(`tour.screen.${active.menuKey}.${anchorId}.title`)}
      body={t(`tour.screen.${active.menuKey}.${anchorId}.body`)}
      onNext={advance}
      onBack={back}
      // Kabuk turunun aksine burada Atla ile Escape aynı şeyi yapar: ekran turu
      // hiçbir şey KALICI YAZMIYOR, dolayısıyla "kazara kapattım" geri
      // alınamaz bir sonuç doğurmuyor — düğmeye basıp yeniden başlatmak yeter.
      onSkip={tour.endScreenTour}
      onEscape={tour.endScreenTour}
    />
  );
}
